import axios from 'axios';
import CryptoJS, { mode } from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import AdminSettingsService from './../../../services/adminsettings.service';
import {Validator} from 'vee-validate';
import CargoAllocationService from '../../../../cargoallocation/services/cargoallocation.service'
import MasterService from '../../../../masterdata/services/masterdata.service'
import ClientService from '../../../../clientmanagement/services/clientmanagement.service'
export default {
  name: 'changedefaulthub',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect
  },
  props: [],
  data: function() {
    return {
      isLoading:false,
      adminsettingdata:[],
      hubid:'',
      hubid1:'',
      redisService: 0,
    }
  },
  computed: {
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    this.currentHub = userdetail.hubID[0];
    // await Promise.all([this.getStatelist(),this.loadAllHubAccessList(),this.getCompanyShortName(),this.getRoleList()]);
    await this.getAdminSettings();

  },
  methods: {
    isIntegerOnly: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
   async getAdminSettings(){
      try {
        this.isLoading = true;
        let inputPayload = {
          username: this.useremail
        }
        let result = await AdminSettingsService.getAdminSettings(inputPayload);
        this.adminsettingdata = result.data.data.settings;
        
        this.redisService = this.getValueByKeyName('REDISSWITCH')[0];
        
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    getValueByKeyName(key) {
      for (var i = 0; i < this.adminsettingdata.length; i++) {
        if (this.adminsettingdata[i].key == key) {
          return this.adminsettingdata[i].value;
        }
      }
    },
    async saveAdminSettings(module,field){
      try {
        this.isLoading = true;
        let inputPayload = {
          username: this.useremail,
        }
        
        if (module == "redis") {
          let tempRedisArr = [];
          tempRedisArr.push(parseInt(this.redisService))
          inputPayload.redisService = tempRedisArr
        }
        let result = await AdminSettingsService.saveAdminSettings(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
		  await this.getAdminSettings();
          this.$alert(result.data.message, "", "success");
        }else{
          this.$alert(result.data.message, "", "error");
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    }, 
  }
}



// WEBPACK FOOTER //
// ./src/modules/adminsettings/views/configuration/redis/redisconfiguration.component.js